import React, { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>;

export default forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16.2C12.4183 16.2 16 12.6182 16 8.19995C16 3.78167 12.4183 0.199951 8 0.199951C3.58172 0.199951 0 3.78167 0 8.19995C0 12.6182 3.58172 16.2 8 16.2ZM5.53033 4.66962C5.23744 4.37673 4.76256 4.37673 4.46967 4.66962C4.17678 4.96251 4.17678 5.43739 4.46967 5.73028L9.18934 10.45H7C6.58579 10.45 6.25 10.7857 6.25 11.2C6.25 11.6142 6.58579 11.95 7 11.95H11C11.4142 11.95 11.75 11.6142 11.75 11.2V7.19995C11.75 6.78574 11.4142 6.44995 11 6.44995C10.5858 6.44995 10.25 6.78574 10.25 7.19995V9.38929L5.53033 4.66962Z"
      fill="#183558"
    />
  </svg>
));
